export const KNOWN_COIN_ICONS = new Set([
  '1inch',
  '2key',
  'aave',
  'abbc',
  'abt',
  'act',
  'ada',
  'adk',
  'adx',
  'ae',
  'aeon',
  'aergo',
  'aeth',
  'agix',
  'agrs',
  'aion',
  'akro',
  'akt',
  'algo',
  'alice',
  'alpha',
  'alt',
  'amp',
  'ampl',
  'anc',
  'ankr',
  'ant',
  'aoa',
  'apl',
  'appc',
  'ar',
  'ardr',
  'ark',
  'arnx',
  'arpa',
  'arrr',
  'asafe',
  'ast',
  'asta',
  'atom',
  'atri',
  'auction',
  'audio',
  'auto',
  'ava',
  'avax',
  'axel',
  'axs',
  'bake',
  'bal',
  'band',
  'bar',
  'basic',
  'bat',
  'bcd',
  'bch',
  'bcha',
  'bcn',
  'beam',
  'bela',
  'belt',
  'best',
  'bf',
  'bifi',
  'bix',
  'block',
  'blz',
  'bmc',
  'bmx',
  'bnana',
  'bnb',
  'bnk',
  'bnt',
  'bnty',
  'bond',
  'bora',
  'bos',
  'botx',
  'bsd',
  'bst',
  'bsv',
  'btc',
  'btcb',
  'btcp',
  'btcst',
  'btcz',
  'btg',
  'btm',
  'btmx',
  'bto',
  'bts',
  'btt',
  'btu',
  'btx',
  'burger',
  'burst',
  'busd',
  'bzrx',
  'cake',
  'cce',
  'ccxx',
  'cdai',
  'cel',
  'celo',
  'celr',
  'cennz',
  'cet',
  'ceth',
  'cfx',
  'chat',
  'chr',
  'chsb',
  'chz',
  'ckb',
  'clam',
  'cloak',
  'cmm',
  'cmt',
  'cnd',
  'cob',
  'colx',
  'comp',
  'coti',
  'crd',
  'cre',
  'cream',
  'cro',
  'crpt',
  'cru',
  'crv',
  'crw',
  'cs',
  'cspr',
  'ctc',
  'ctk',
  'ctsi',
  'ctxc',
  'cube',
  'cusd',
  'cusdc',
  'cusdt',
  'cvc',
  'cvt',
  'cxo',
  'dag',
  'dai',
  'dao',
  'dash',
  'dat',
  'data',
  'dawn',
  'dbc',
  'dcn',
  'dcr',
  'ddx',
  'dego',
  'dent',
  'dfi',
  'dgb',
  'dgd',
  'dia',
  'divi',
  'dlt',
  'dmt',
  'dnt',
  'dock',
  'dodo',
  'doge',
  'dot',
  'drc',
  'drg',
  'drs',
  'dth',
  'dusk',
  'dvi',
  'dvpn',
  'ebst',
  'eca',
  'edg',
  'egld',
  'egr',
  'egt',
  'ekt',
  'ela',
  'elf',
  'ella',
  'emc',
  'emc2',
  'eng',
  'enj',
  'eos',
  'erg',
  'ern',
  'ersdl',
  'esbc',
  'esd',
  'etc',
  'eth',
  'etn',
  'etp',
  'etz',
  'eum',
  'eurs',
  'evx',
  'ewt',
  'exp',
  'exrd',
  'face',
  'fct',
  'fei',
  'fet',
  'fida',
  'fil',
  'fio',
  'firo',
  'fjc',
  'flm',
  'flow',
  'forth',
  'frax',
  'fsn',
  'ftc',
  'ftm',
  'ftt',
  'fuel',
  'fun',
  'fx',
  'fxs',
  'gal',
  'gala',
  'game',
  'gas',
  'gbx',
  'ghst',
  'gin',
  'glm',
  'gls',
  'gno',
  'grc',
  'grin',
  'grs',
  'grt',
  'gsc',
  'gt',
  'gtc',
  'gusd',
  'gvt',
  'gxc',
  'hai',
  'hakka',
  'hbar',
  'hbtc',
  'hc',
  'hedg',
  'hex',
  'hive',
  'hns',
  'hnt',
  'hoge',
  'hot',
  'hpp',
  'ht',
  'html',
  'htr',
  'hum',
  'husd',
  'hush',
  'hxro',
  'hydro',
  'icp',
  'icx',
  'idex',
  'ignis',
  'ihf',
  'inb',
  'inj',
  'ink',
  'ino',
  'ion',
  'iop',
  'iost',
  'iotx',
  'iq',
  'iqn',
  'iris',
  'itc',
  'jst',
  'kai',
  'karma',
  'kat',
  'kava',
  'kcs',
  'keep',
  'key',
  'kin',
  'klay',
  'klv',
  'kmd',
  'knc',
  'kndc',
  'kok',
  'krb',
  'ksm',
  'ksp',
  'la',
  'lbc',
  'ldo',
  'leo',
  'lido',
  'like',
  'lina',
  'link',
  'lkk',
  'lon',
  'loom',
  'lpt',
  'lqty',
  'lrc',
  'lrg',
  'lsk',
  'ltc',
  'lto',
  'lun',
  'luna',
  'lusd',
  'lym',
  'maapl',
  'maid',
  'mana',
  'mask',
  'mass',
  'math',
  'matic',
  'mbl',
  'mco',
  'mda',
  'mds',
  'mdx',
  'med',
  'meetone',
  'met',
  'meta',
  'mft',
  'mina',
  'miota',
  'mir',
  'mith',
  'mkr',
  'mlk',
  'mln',
  'mns',
  'moac',
  'mof',
  'mona',
  'mph',
  'msr',
  'mth',
  'mtl',
  'mvl',
  'mwc',
  'mx',
  'mxc',
  'myst',
  'Name=Atari Token (ATRI)',
  'Name=Kanadecoin (Kndc)',
  'Name=Ongsocial (Ong)',
  'Name=PERL.eco (PERL)',
  'Name=Revain (REV)',
  'Name=Rlc (Rlc)',
  'nano',
  'nas',
  'nav',
  'ncash',
  'nct',
  'near',
  'nebl',
  'neo',
  'nest',
  'neu',
  'new',
  'nexo',
  'nft',
  'nftx',
  'ngc',
  'nim',
  'nkn',
  'nlc2',
  'nlg',
  'nmc',
  'nmr',
  'noia',
  'nrg',
  'nu',
  'nuls',
  'nwc',
  'nxm',
  'nxt',
  'nye',
  'oax',
  'ocean',
  'ode',
  'ogn',
  'ok',
  'okb',
  'om',
  'omg',
  'omni',
  'one',
  'ong',
  'ont',
  'oot',
  'orbs',
  'orc',
  'ouro',
  'oxen',
  'oxt',
  'oxy',
  'pac',
  'part',
  'pasc',
  'pax',
  'paxg',
  'pay',
  'payx',
  'pbtc',
  'pcx',
  'pearl',
  'perl',
  'perp',
  'pha',
  'pink',
  'pirl',
  'pivx',
  'plbt',
  'plc',
  'plr',
  'plt',
  'pltc',
  'plu',
  'pma',
  'pnk',
  'pnt',
  'poe',
  'polis',
  'pols',
  'poly',
  'pond',
  'pot',
  'powr',
  'ppc',
  'ppp',
  'ppt',
  'pre',
  'pro',
  'prom',
  'prq',
  'ptoy',
  'pundix',
  'pyr',
  'qash',
  'qkc',
  'qlc',
  'qnt',
  'qqq',
  'qrl',
  'qsp',
  'qtum',
  'qun',
  'ramp',
  'rari',
  'ray',
  'rbtc',
  'rcn',
  'rdd',
  'rdn',
  'reef',
  'ren',
  'renbtc',
  'rep',
  'req',
  'rev',
  'revv',
  'rfox',
  'rfr',
  'rif',
  'rise',
  'rlc',
  'rly',
  'rose',
  'rsr',
  'rsv',
  'ruff',
  'rune',
  'rvn',
  'ryo',
  'safemoon',
  'salt',
  'san',
  'sand',
  'sapp',
  'sbd',
  'sc',
  'scrt',
  'seele',
  'sfp',
  'shft',
  'shib',
  'shift',
  'ship',
  'shr',
  'shroom',
  'sib',
  'skl',
  'sky',
  'slp',
  'slr',
  'sls',
  'smart',
  'sngls',
  'snm',
  'snow',
  'snt',
  'snx',
  'soc',
  'sol',
  'solo',
  'soul',
  'spank',
  'sphtx',
  'srm',
  'srn',
  'stak',
  'stake',
  'start',
  'steem',
  'stmx',
  'storj',
  'stq',
  'strax',
  'strk',
  'strong',
  'stx',
  'sub',
  'sumo',
  'super',
  'susd',
  'sushi',
  'suter',
  'swap',
  'swth',
  'sxp',
  'sys',
  'tau',
  'tbx',
  'tch',
  'tel',
  'ten',
  'tera',
  'tern',
  'tfuel',
  'theta',
  'thr',
  'titan',
  'tix',
  'tkn',
  'tko',
  'tks',
  'tlm',
  'tlos',
  'tnb',
  'tnc',
  'tnt',
  'tomo',
  'tor',
  'torn',
  'tpay',
  'trac',
  'trb',
  'tribe',
  'trtl',
  'trx',
  'tt',
  'ttt',
  'tusd',
  'tvk',
  'twt',
  'tzc',
  'ubq',
  'ubt',
  'ult',
  'uma',
  'uni',
  'uos',
  'uqc',
  'usdc',
  'usdn',
  'usdt',
  'ust',
  'utk',
  'vai',
  'vbnb',
  'vee',
  'veil',
  'veri',
  'vet',
  'vgx',
  'via',
  'vibe',
  'vite',
  'vlx',
  'vra',
  'vrc',
  'vrsc',
  'vrt',
  'vsys',
  'vtc',
  'vtho',
  'wan',
  'waves',
  'waxp',
  'wbnb',
  'wbtc',
  'wgro',
  'wicc',
  'win',
  'wing',
  'wings',
  'wnxm',
  'woo',
  'wozx',
  'wpr',
  'wrx',
  'wtc',
  'xas',
  'xbc',
  'xby',
  'xcm',
  'xcp',
  'xdb',
  'xdc',
  'xdn',
  'xem',
  'xhv',
  'xin',
  'xlm',
  'xmr',
  'xmx',
  'xmy',
  'xnc',
  'xor',
  'xpa',
  'xpm',
  'xpr',
  'xprt',
  'xrp',
  'xsr',
  'xtz',
  'xuc',
  'xvg',
  'xvs',
  'xwc',
  'xym',
  'xyo',
  'yfi',
  'youc',
  'yoyow',
  'zb',
  'zcl',
  'zec',
  'zel',
  'zen',
  'zeon',
  'zil',
  'zks',
  'zlw',
  'znn',
  'zrx',
]);
